import { ContentType } from '@insided/shared/utils/contentType'
import { Config, Reply } from './interfaces'
import { createContext } from 'preact-compat'

export function showEscalateButton (escalateTopic: boolean, escalateReply: boolean, isReply: boolean, hasUrl: boolean, contentType: ContentType) {
  if (hasUrl) {
    return true
  }
  if (isReply) {
    return true
    // TODO: replace return when new topic moderation page is used for all content types
    // return escalateReply
  }
  return !(contentType === 'article' || contentType === 'productUpdate')
  // TODO: replace return when new topic moderation page is used for all content types
  // return escalateTopic
}

export function getFormattedTitle (title: string = '', isReply: boolean = false) {
  const formattedTitle = isReply ? `RE: ${title ?? ''}` : title

  return formattedTitle.length > 150 ? formattedTitle.slice(0, 147) + '...' : formattedTitle
}

export function getFormattedContent (contentType: ContentType, destinationUrl: string, topicId: number, content?: string | null) {
  const formattedContentType = contentTypeMapping[contentType]
  let url = destinationUrl
  if (['productUpdate', 'idea'].includes(contentType)) {
    url = `${destinationUrl}${formattedContentType}/${topicId}`
  }

  return `${content ?? ''} \n \n------------------\n${url} `
}

export function getAllVisibleReplies (replies: Reply[]) {
  const filteredReplies = replies.filter((reply: Reply) => (!reply.trashed && !reply.spam))
  return filteredReplies.map((reply: Reply) => reply.id)
}

export function filterSelectedReplies (replies: string[], selectedReplyId: string | undefined) {
  if (selectedReplyId === undefined) return []
  return replies.filter((id: string) => selectedReplyId !== id)
}

export function filterReplyForBulkAction (contentType: ContentType, topics?: Reply[]) {
  return topics?.map((object: Reply) => {
    return {
      ...object,
      contentType: contentType,
      replyId: object.id
    }
  })
}

export function toggleReplyOnTrash (replies: Reply[], replyId: string) {
  return replies.map((reply: Reply) => {
    if (reply.id === replyId) {
      return {
        ...reply,
        trashed: !reply.trashed
      }
    }
    return reply
  })
}

export const contentTypeMapping: Record<ContentType, string> = {
  discussion: 'conversations',
  productUpdate: 'product-updates',
  idea: 'ideas',
  question: 'questions',
  article: 'articles',
  conversation: 'conversations'
}

export const ConfigContext = createContext<Config>({
  contentTypeConfig: {
    assignModerator: false,
    changeAuthor: false,
    convertToArticle: false,
    convertToConversation: false,
    convertToIdea: false,
    convertToProductUpdate: false,
    convertToQuestion: false,
    copyTopic: false,
    featuredImage: false,
    forum: false,
    ideaStatus: false,
    like: false,
    markAsUnread: false,
    moderationLabel: false,
    pending: false,
    pendingReply: false,
    pinReply: false,
    productAreas: false,
    publicLabel: false,
    spam: false,
    spamReply: false,
    sticky: false,
    trash: false,
    trashReply: false,
    versionHistory: false,
    vote: false,
    moveReplyToExistingTopic: false,
    moveTopicToExistingTopic: false
  },
  moderationConfig: {
    contentHelpfulness: false,
    escalate: false,
    escalateReply: false,
    subscribe: false
  }
})
